<template>
  <vs-popup title="Nuevo método de pago" :active.sync="show">
    <div class="card">
      <div class="card-body">
        <form
          v-loading="loading"
          element-loading-text="Guardando..."
          @submit.prevent="store('new-payment-method')"
          data-vv-scope="new-payment-method"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Nombre método de pago</label>
                <el-input
                  v-model="paymentMethod.name"
                  name="name"
                  v-validate="'required'"
                ></el-input>
                <label
                  v-show="errors.has('new-payment-method.name')"
                  class="error"
                >
                  {{ errors.first("new-payment-method.name") }}
                </label>
              </div>
            </div>
          </div>

          <div class="text-center mt-30">
            <vs-button button="submit" type="filled">
              Guardar
            </vs-button>
          </div>
        </form>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import utilitiesService from "@/services/utilities.service";

export default {
  props: {
    vis: {
      type: Boolean,
      default: false
    },
    company_id: {
      type: Number
    }
  },
  name: "new-payment-method-modal",
  data() {
    return {
      show: false,
      paymentMethod: {
        company_id: "",
        name: ""
      },
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("closeModal", false);
      this.resetDataForm();
    },
    resetDataForm() {
      Object.assign(
        this.$data.paymentMethod,
        this.$options.data().paymentMethod
      );
      this.$validator.reset();
    },
    store(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let paymentMethod = this.paymentMethod;
          paymentMethod.company_id = this.company_id;
          utilitiesService
            .storePaymentMethod(paymentMethod)
            .then(res => {
              if (res.data.success) {
                this.$emit("storePaymentMethod", res.data.item);
                /*this.$notify({
                title: 'Método de pago agregado correctamente.',
                type: 'success',
                duration: 1500
              });*/
                //JRA Cambio de notificacion por mensaje
                this.$message({
                  showClose: true,
                  message: "Método de pago agregado correctamente.",
                  type: "success",
                  duration: 1500
                });
              } else {
                this.close();
                /*this.$notify({
                title: res.data.message,
                type: 'warning'
              });*/
                //JRA Cambio de notificacion por mensaje
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "warning"
                });
              }
              this.loading = false;
              this.resetDataForm();
            })
            .catch(error => {
              /*this.$notify({
              title: error.message,
              type: 'error'
            });*/
              //JRA Cambio de notificacion por mensaje
              this.$message({
                showClose: true,
                message: error.message,
                type: "error"
              });
              this.loading = false;
            });
        } else {
          /*this.$notify({
              title: 'invalido',
              type: 'error'
            });*/
          //JRA Cambio de notificacion por mensaje
          this.$message({
            showClose: true,
            message: "invalido",
            type: "error"
          });
          this.loading = false;
        }
      });
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        this.close();
      }
    },
    vis(newVal) {
      this.show = newVal;
    }
  }
};
</script>

<style scoped>
.el-input-number .el-input .el-input__inner {
  width: 100% !important;
  background: red;
}
.el-date-editor {
  width: 100% !important;
}
.el-input__inner {
  display: block;
  width: 100% !important;
}
.mt-30 {
  margin-top: 30px;
}
</style>
